$(function () {
    'use-strict';

    let maxPrizes = 12;

    let $addPrize = $('#add-prize');
    let $prizes = $('#prizes');

    let $rowPrizeTmpl = $('#row-prize-tmpl');
    $rowPrizeTmpl.attr('id', '').removeClass('hidden').remove();

    let prizeIndex = $prizes.children('.row-prize').length;

    function addPrize(e) {
        let $clone = $rowPrizeTmpl.clone();

        $clone.find('input').each((index, el) => {
            let $el = $(el);
            let name = $el.prop('name');

            // Set the correct indexes to the arrays (prop name).
            name = name.replace(/^(prizes\[)(\d+)(\].*)$/, '$1' + prizeIndex + '$3');
            $el.prop('name', name);

            if (/^prizes\[\d+\]\[index\]$/.test(name)) {
                // Set the correct index to value the input field with [index] in prop name.
                $el.val(prizeIndex);
            }
        });

        // Set the correct index to label "for" and input "id" of custom-controls.
        $clone.find('.custom-control').each((index, el) => {
            let $el = $(el);
            let $input = $el.find('[id^="custom"]');
            let $label = $el.find('[for^="custom"]');
            let id = $input.attr('id').replace(/(.*-)\d+/, '$1' + prizeIndex);

            $input.attr('id', id);
            $label.attr('for', id);
        });

        // Manually check custom_dates checked property ( it is not checked if only the html template is checked !?).
        $clone.find('input[name*="[custom_dates]"][value="false"]').prop('checked', true);

        $prizes.append($clone);
        $prizes.data('index', ++prizeIndex);

        checkMaxPrizes();
    }

    function checkMaxPrizes() {
        let totalPrizes = $prizes.children('.row-prize').length;

        if (totalPrizes >= maxPrizes) {
            $addPrize.addClass('hidden');
        } else {
            $addPrize.removeClass('hidden');
        }
    }

    function removePrize(e) {
        let $el = $(e.currentTarget);
        let $prize = $el.closest('.row-prize');
        let $prizeWithId = $prize.find('input[name*="[id]"]');

        if ($prizeWithId.length) {
            // Add prize to list of prizes to be removed.
            let $form = $prize.closest('form');
            $form.prepend('<input type="hidden" name="prizes_to_delete[]" value="' + $prizeWithId.val() + '" />');
        }

        $prize.remove();
        checkMaxPrizes();
    }

    function updateRangeDisplay(e) {
        let $el = $(e.currentTarget);
        let $output = $el.closest('.custom-control').find('.output');
        $output.text($el.val());
    }

    checkMaxPrizes();

    // Interaction with range.
    $(document).on('input', 'input[type="range"]', (e) => {
        updateRangeDisplay(e);
    });

    // Interaction with remove button of each prize.
    $(document).on('click', '.remove-prize', (e) => {
        removePrize(e);
    });

    // Interaction with "add" button.
    $addPrize.on('click', (e) => {
        addPrize(e);
    });
});
